export const LightIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9999 19V20M11.9999 4V5M7.05018 16.9497L6.34307 17.6569M17.6568 6.34315L16.9497 7.05025M7.05027 7.05017L6.34316 6.34306M17.6567 17.6569L16.9496 16.9498M5.00012 12H4.00012M19.9999 12H18.9999M17 12C17 14.7614 14.7614 17 12 17C9.23855 17 6.99997 14.7614 6.99997 12C6.99997 9.23857 9.23855 7 12 7C14.7614 7 17 9.23857 17 12Z"
        stroke="#222222" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
